import { render } from "./ScrollableContainer.vue?vue&type=template&id=4584eb35&scoped=true"
import script from "./ScrollableContainer.vue?vue&type=script&lang=js"
export * from "./ScrollableContainer.vue?vue&type=script&lang=js"

import "./ScrollableContainer.vue?vue&type=style&index=0&id=4584eb35&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4584eb35"],['__file',"src/scripts/common/sideBars/components/ScrollableContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4584eb35"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4584eb35', __exports__)) {
    api.reload('4584eb35', __exports__)
  }
  
  module.hot.accept("./ScrollableContainer.vue?vue&type=template&id=4584eb35&scoped=true", () => {
    api.rerender('4584eb35', render)
  })

}


export default __exports__